import React, {ReactElement, useMemo} from 'react';
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

interface GridProps {
  data: any;
  columns: any;
  pagination?: any;
  onCellValueChanged?: any;
  paginationPageSize?: any;
  editable?: any;
  getRowStyle?: any;
  rowStyle?: any;
  getRowClass?: any;
  rowClassRules?: any;
}

const AgGridTable = (props: GridProps): ReactElement => {
  const {
    data,
    columns,
    pagination,
    onCellValueChanged,
    editable,
    paginationPageSize,
    getRowStyle,
    rowStyle,
    getRowClass,
    rowClassRules
  } = props;
  const defaultColDef = useMemo(() => {
    return {
      editable: editable || false,
      enableRowGroup: true,
      enablePivot: true,
      enableValue: true,
      sortable: true,
      resizable: true,
      filter: true,
      cellStyle: {
        fontSize: '1rem'
        // display: 'flex',alignItems: 'center'
      },
      autoHeight: true
    };
  }, [editable]); // Added `editable` as a dependency

  return (
    <div className="ag-theme-alpine" style={{height: '100%', width: '100%'}}>
      <AgGridReact
        rowData={data}
        columnDefs={columns}
        // onGridReady={onGridReady}
        pagination={pagination}
        paginationPageSize={paginationPageSize || 30}
        defaultColDef={defaultColDef}
        onCellValueChanged={onCellValueChanged}
        getRowStyle={getRowStyle}
        rowStyle={rowStyle}
        getRowClass={getRowClass}
        rowClassRules={rowClassRules}
        // suppressRowClickSelection={true}
        // groupSelectsChildren={true}
        // rowSelection={'multiple'}
        // rowGroupPanelShow={'always'}
        // pivotPanelShow={'always'}
      />
    </div>
  );
};

export default AgGridTable;
